import React from "react";
import { SectionLabel, Reveal } from "../primitives";
import { Section, BODY_DARK } from "../shared";
import { vorstellen } from "../content";

const headline = [
  "Tun, was Du liebst.",
  "Dabei echten Mehrwert für andere schaffen.",
  "UND nebenbei richtig gut dafür bezahlt werden.",
];

export default function VorstellenSection() {
  return (
    <Section testId="vorstellen-section" className="bg-espresso py-24 text-gold md:py-36">
      <SectionLabel color="gold" testId="vorstellen-label">Stell Dir mal vor…</SectionLabel>
      <div className="space-y-10">
        {vorstellen.map((v, i) => (
          <Reveal key={v.t} delay={i * 0.07}>
            <div className={`flex max-w-3xl items-start gap-5 ${i % 2 === 1 ? "md:ml-16" : ""}`}>
              <span className="mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-cognac-light/60 text-cognac-light">
                <v.icon className="h-5 w-5" />
              </span>
              <p className={BODY_DARK}>{v.t}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <div className="mt-20 grid gap-12 md:grid-cols-12 md:items-center">
        <div className="md:col-span-7">
          {headline.map((line, i) => (
            <Reveal key={line} delay={i * 0.1}>
              <p
                className={`font-heading font-700 uppercase leading-[1.05] tracking-tight text-[clamp(1.6rem,4.4vw,3rem)] ${i === 2 ? "text-cognac-light" : "text-gold"}`}
                style={{ fontWeight: 700 }}
              >
                {line}
              </p>
            </Reveal>
          ))}
          <Reveal delay={0.34}>
            <p className="mt-8 font-body text-xl italic text-gold/85">That's what we're doing over here. 🫦</p>
          </Reveal>
        </div>
        <div className="md:col-span-5">
          <Reveal delay={0.2}>
            <video
              autoPlay
              muted
              loop
              playsInline
              data-testid="vorstellen-video"
              className="mx-auto w-full max-w-[300px] rounded-sm shadow-[0_30px_60px_-25px_rgba(0,0,0,0.6)] md:max-w-[340px]"
            >
              <source src="/videos/luisa-brille.webm" type="video/webm" />
              <source src="/videos/luisa-brille.mp4" type="video/mp4" />
            </video>
          </Reveal>
        </div>
      </div>
    </Section>
  );
}
